import { CurrentCardService, MyCardService } from '@addins/core/core';
import { AttachmentService } from '@addins/media';
import { Injectable } from '@angular/core';
import { AddAttachmentCardButton } from '../../schema/add-attachment-card-button';

@Injectable()
export class AddAttachmentCardButtonControllerService {
  private addAttachmentCardButton: AddAttachmentCardButton = null;

  constructor(
    private currentCardService: CurrentCardService,
    private myCardService: MyCardService,
    private attachmentService: AttachmentService
  ) {}

  setup(addAttachmentCardButton: AddAttachmentCardButton) {
    this.addAttachmentCardButton = addAttachmentCardButton;

    this.currentCardService.$change.subscribe(() => this.onCardChanged());
    this.myCardService.$change.subscribe(() => this.onCardChanged());

    this.addAttachmentCardButton.onClick.subscribe(event => this.attachmentService.createAttachment(event.target.ObjGuid));
  }

  private onCardChanged() {
    this.addAttachmentCardButton.show =
      this.myCardService.myCard !== null &&
      this.currentCardService.current !== null &&
      this.currentCardService.current.ObjGuid === this.myCardService.myCardId;
  }
}
